import { Component, afterNextRender } from '@angular/core';
import { NavigationComponent } from '../../shared/components/navigation/navigation.component';
import { AtmosphereComponent } from './components/atmosphere/atmosphere.component';
import { BrandSectionComponent } from './components/brand-section/brand-section.component';
import { CompoundSectionComponent } from './components/compound-section/compound-section.component';
import { FinalCtaComponent } from './components/final-cta/final-cta.component';
import { HeroComponent } from './components/hero/hero.component';
import { PersonalizationSectionComponent } from './components/personalization-section/personalization-section.component';
import { SignalsSectionComponent } from './components/signals-section/signals-section.component';
import { FooterComponent } from './components/footer/footer.component';

@Component({
  selector: 'app-landing-page',
  standalone: true,
  host: {
    class: 'landing-page',
  },
  imports: [
    NavigationComponent,
    AtmosphereComponent,
    HeroComponent,
    CompoundSectionComponent,
    PersonalizationSectionComponent,
    SignalsSectionComponent,
    BrandSectionComponent,
    FinalCtaComponent,
    FooterComponent,
  ],
  template: `
    <app-atmosphere />
    <app-navigation />
    <main>
      <app-hero />
      <app-compound-section />
      <app-personalization-section />
      <app-signals-section />
      <app-brand-section />
      <app-final-cta />
    </main>
    <app-footer />
  `,
  styleUrl: './landing-page.component.scss',
})
export class LandingPageComponent {
  constructor() {
    afterNextRender(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('in');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15 },
      );
      document
        .querySelectorAll('.reveal')
        .forEach((el) => observer.observe(el));
    });
  }
}
